import LoginComponent from "@/components/LoginComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";
import CancelComponent from "@/components/stripe/CancelComponent.vue";
import Payementcomponent from "@/components/stripe/PayementComponent.vue";
import SuccesComponent from "@/components/stripe/SuccesComponent.vue";
import TestComponent from "@/components/TestComponent.vue";
import TestonsComponent from "@/components/TestonsComponent.vue";
import AboutComponent from "@/views/about-us/AboutComponent.vue";
import ArtisteComponent from "@/views/artist/ArtisteComponent.vue";
import ContactComponent from "@/views/contact/ContactComponent.vue";
import IndexComponent from "@/views/gallerie/indexComponent.vue";
import HomeComponent from "@/views/landing/HomeComponent.vue";
import NotfoundComponent from "@/views/notfoundComponent.vue";
import PartenaireComponent from "@/views/partners/PartenaireComponent.vue";
import ProgrammeComponent from "@/views/program/ProgrammeComponent.vue";
import ReservationComponent from "@/views/ReservationComponent.vue";
import TableComponent from "@/views/TableComponent.vue";
import TicketComponent from "@/views/TicketComponent.vue";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    component: LoginComponent,
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotfoundComponent,
  },
  {
    path: "/",
    component: NavbarComponent,
    children: [
      {
        path: "",
        components: {
          default: NavbarComponent,
          one: HomeComponent,
        },
      },
      {
        path: "/partenaires",
        components: {
          default: NavbarComponent,
          one: PartenaireComponent,
        },
      },
      {
        path: "/a-propos",
        components: {
          default: NavbarComponent,
          one: AboutComponent,
        },
      },
      {
        path: "/Artistes",
        components: {
          default: NavbarComponent,
          one: ArtisteComponent,
        },
      },
      {
        path: "/Contact",
        components: {
          default: NavbarComponent,
          one: ContactComponent,
        },
      },
      {
        path: "/Programme",
        components: {
          default: NavbarComponent,
          one: ProgrammeComponent,
        },
      },
      {
        path: "/Tickets",
        components: {
          default: NavbarComponent,
          one: TicketComponent,
        },
      },
      {
        path: "/Tables",
        components: {
          default: NavbarComponent,
          one: TableComponent,
        },
      },
      {
        path: "/Reservations",
        components: {
          default: NavbarComponent,
          one: ReservationComponent,
        },
      },

      {
        path: "/test",
        components: {
          default: NavbarComponent,
          one: TestComponent,
        },
      },
      {
        path: "/payement",
        components: {
          default: NavbarComponent,
          one: Payementcomponent,
        },
      },
      {
        path: "/gallery",
        components: {
          default: NavbarComponent,
          one: IndexComponent,
        },
      },
      // gallery
      {
        path: "/success",
        components: {
          default: NavbarComponent,
          one: SuccesComponent,
        },
      },
      {
        path: "/cancel",
        components: {
          default: NavbarComponent,
          one: CancelComponent,
        },
      },

            {
        path: "/binks",
        components: {
          default: NavbarComponent,
          one: TestonsComponent,
        },
      },

    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
